(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('action-rms-get-listview-dataitem', actionFunc);

    function actionFunc($q) {
        return function() {
            const args = arguments;
            return $q.when(run());
            function run() {
                if (args[2]) {
                    const evtData = args[2];
                    const listObj = evtData.target.parents('.k-listview').data('kendoListView');
                    return listObj.dataItem(evtData.target.parents('div'));
                }
                return null;
            }
        };
    }
})();
